import { Link } from "react-router-dom";
import { InstagramLogo, LinkedinLogo, FacebookLogo, XLogo } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ocean text-parchment relative grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img
            src="https://youngindians.net/wp-content/uploads/2022/10/YI-PNG-logo-e1680601364574.png"
            alt="Young Indians logo"
            className="h-12 w-auto brightness-0 invert mb-8"
          />
          <div className="overline text-saffron">Yi Kozhikode</div>
          <h3 className="font-serif text-4xl md:text-5xl mt-4 leading-none">
            We Can.
            <br />
            <span className="italic text-saffron">We Will.</span>
          </h3>
          <p className="mt-6 max-w-md text-parchment/70 text-sm leading-relaxed">
            The local chapter of Young Indians at Kozhikode — heirs to a 1,000-year trading
            legacy, building India’s next chapter.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-parchment/50 mb-5">Navigate</div>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-link-home" to="/" className="hover:text-brass">Home</Link></li>
            <li><Link data-testid="footer-link-initiatives" to="/initiatives" className="hover:text-brass">Initiatives</Link></li>
            <li><Link data-testid="footer-link-heritage" to="/heritage" className="hover:text-brass">Maritime Heritage</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-brass">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-parchment/50 mb-5">Reach us</div>
          <p className="text-sm text-parchment/70 leading-relaxed">
            Yi Kozhikode Chapter<br />
            c/o CII Office, Kozhikode<br />
            Kerala, India
          </p>
          <div className="flex gap-4 mt-6">
            <a href="#" data-testid="social-instagram" className="hover:text-brass" aria-label="Instagram"><InstagramLogo size={20} /></a>
            <a href="#" data-testid="social-linkedin" className="hover:text-brass" aria-label="LinkedIn"><LinkedinLogo size={20} /></a>
            <a href="#" data-testid="social-facebook" className="hover:text-brass" aria-label="Facebook"><FacebookLogo size={20} /></a>
            <a href="#" data-testid="social-x" className="hover:text-brass" aria-label="X"><XLogo size={20} /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row gap-3 justify-between text-xs text-parchment/50">
          <div>© {new Date().getFullYear()} Yi Kozhikode · A Young Indians chapter · CII initiative</div>
          <div className="overline">Made on the Malabar Coast</div>
        </div>
      </div>
    </footer>
  );
}
